document.documentElement.style.fontSize = '16px'
